import CanvasController from './canvas-controller.js';
import { palette } from '../color.js';
import { generateChirplet, chirpletMatch, generateLinearChirp } from '../chirp-things.js';

export default class ChirpMatchController extends CanvasController {

    constructor(id, width, height) {
        super(id, width, height);
        
        this.numSamples = 256;
        this.signal = generateLinearChirp(0.02, 0.12, this.numSamples);
        
        this.probeT0 = 0.5;
        this.probeF0 = 0.07;
        this.probeChirpRate = 0;
        this.probeSigma = 30;
        
        this.matchMagnitude = 0;
        this.updateMatch();
    }

    setSignal(signal) {
        this.signal = signal;
        this.numSamples = signal.length;
        this.updateMatch();
    }

    setProbeT0(t0) {
        this.probeT0 = t0;
        this.updateMatch();
    }

    setProbeF0(f0) {
        this.probeF0 = f0;
        this.updateMatch();
    }

    setProbeChirpRate(rate) {
        this.probeChirpRate = rate;
        this.updateMatch();
    }

    updateMatch() {
        const result = chirpletMatch(
            this.signal, 
            this.probeT0, 
            this.probeF0, 
            this.probeChirpRate, 
            this.probeSigma
        );
        this.matchMagnitude = result.magnitude;
    }

    update(dt, mousePosition) {
    }

    render() {
        this.clear();
        this.context.save();
        
        this.renderSignal();
        this.renderProbeChirplet();
        this.renderMatchMeter();
        
        this.context.restore();
    }

    renderSignal() {
        const margin = 40;
        const waveHeight = 80;
        const waveY = 100;
        const waveWidth = this.canvas.width - 2 * margin;
        
        this.context.strokeStyle = palette.blue;
        this.context.lineWidth = 2;
        this.context.beginPath();
        
        for (let i = 0; i < this.signal.length; i++) {
            const x = margin + (i / this.signal.length) * waveWidth;
            const y = waveY - this.signal[i] * waveHeight;
            
            if (i === 0) {
                this.context.moveTo(x, y);
            } else {
                this.context.lineTo(x, y);
            }
        }
        this.context.stroke();
    }

    renderProbeChirplet() {
        const margin = 40;
        const waveHeight = 80;
        const waveY = 100;
        const waveWidth = this.canvas.width - 2 * margin;
        
        const probe = generateChirplet(
            this.probeT0, 
            this.probeF0, 
            this.probeChirpRate, 
            this.probeSigma, 
            this.numSamples
        );
        
        this.context.strokeStyle = '#ff9933';
        this.context.lineWidth = 2;
        this.context.globalAlpha = 0.8;
        this.context.beginPath();
        
        for (let i = 0; i < probe.length; i++) {
            const x = margin + (i / probe.length) * waveWidth;
            const y = waveY - probe[i] * waveHeight;
            
            if (i === 0) {
                this.context.moveTo(x, y);
            } else {
                this.context.lineTo(x, y);
            }
        }
        this.context.stroke();
        this.context.globalAlpha = 1;
        
        const probeX = margin + this.probeT0 * waveWidth;
        this.context.strokeStyle = '#ff9933';
        this.context.lineWidth = 1;
        this.context.setLineDash([5, 5]);
        this.context.beginPath();
        this.context.moveTo(probeX, waveY - waveHeight - 20);
        this.context.lineTo(probeX, waveY + waveHeight + 20);
        this.context.stroke();
        this.context.setLineDash([]);
    }

    renderMatchMeter() {
        const meterX = 40;
        const meterY = this.canvas.height - 80;
        const meterWidth = this.canvas.width - 80;
        const meterHeight = 30;
        
        this.context.fillStyle = '#333';
        this.context.fillRect(meterX, meterY, meterWidth, meterHeight);
        
        const normalizedMatch = Math.min(1, this.matchMagnitude * 2);
        const hue = normalizedMatch * 120;
        this.context.fillStyle = `hsl(${hue}, 80%, 50%)`;
        this.context.fillRect(meterX, meterY, meterWidth * normalizedMatch, meterHeight);
        
        this.context.strokeStyle = '#666';
        this.context.lineWidth = 2;
        this.context.strokeRect(meterX, meterY, meterWidth, meterHeight);
        
        this.context.fillStyle = '#fff';
        this.context.font = 'bold 14px sans-serif';
        this.context.fillText('Match:', meterX, meterY - 10);
        
        this.context.fillStyle = '#999';
        this.context.font = '12px sans-serif';
        const matchPercent = Math.round(normalizedMatch * 100);
        this.context.fillText(`${matchPercent}%`, meterX + meterWidth + 10, meterY + 20);
    }
}
